/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import CardBody from './CardBody';
import CardHeader from './CardHeader';
import CardFooter from './CardFooter';

import markerIcon from '../../data/markerIcon';
import { PRIMARY_LOCATION_TYPES, LOCATION_CONTENT_KEY } from '../../constants';

import { getLocationHeaderType } from '../../lib/LocationDetailsUtils';

import './Card.scss';

/**
 * @description Card
 *
 * @returns {<Card />}
 */
const Card = props => {
  const {
    location,
    primaryLink,
    secondaryLink,
    showTertiaryLabel,
    handleClose,
    content,
    type,
    handleLinkClick,
    bodyRef,
    showFooter,
  } = props;

  // Initialize empty card when loading first location. This is useful to trigger the initial
  // transition animation. This can also be extended to show a loading animation.
  if (!location || !type) return <div />;

  const headerText = content.header[LOCATION_CONTENT_KEY[getLocationHeaderType(type, location)]];
  const headerIcon = markerIcon[type].types.pin;

  // Get footer links and labels.
  const isPrimaryLink = PRIMARY_LOCATION_TYPES.includes(type);
  let buttonType = '';

  if (showTertiaryLabel) {
    buttonType = 'tertiary';
  } else {
    buttonType = isPrimaryLink ? 'primary' : 'secondary';
  }

  const { label: footerLabel } = content.body.buttons[buttonType];
  const urlQuery = location.country === 'United States' ? `?zip_code=${location.postal}` : '';
  const newfooterLink = isPrimaryLink ? `${primaryLink}${urlQuery}` : secondaryLink;

  return (
    <React.Fragment>
      <CardHeader icon={headerIcon} text={headerText} handleClose={handleClose} />
      <CardBody location={location} content={content} bodyRef={bodyRef} />
      {showFooter && (
        <CardFooter
          primary={isPrimaryLink}
          link={newfooterLink}
          label={footerLabel}
          handleClick={() => handleLinkClick({ primary: isPrimaryLink })}
        />
      )}
    </React.Fragment>
  );
};

Card.defaultProps = {
  location: null,
  type: null,
  bodyRef: null,
  content: {},
  showFooter: true,
};

Card.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleLinkClick: PropTypes.func.isRequired,
  primaryLink: PropTypes.string.isRequired,
  secondaryLink: PropTypes.string.isRequired,
  showTertiaryLabel: PropTypes.bool.isRequired,
  location: PropTypes.object,
  content: PropTypes.object,
  type: PropTypes.string,
  bodyRef: PropTypes.func,
  showFooter: PropTypes.bool,
};

export default Card;
